import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Controller } from 'react-hook-form';
import AsyncSelect from 'react-select/async';
import { fetchPickListDetailsAutoComplete } from '../../../store/apis/autocompleteService';
import { CLAIM_FORM_TYPES } from '../../../pages/ExpenseClaims/Employee/EmployeeExpenseClaim/constants';

export default function PickListDetailsElement({
  formMethods,
  name,
  type = 'COUNTRY',
  config = null,
  formType,
  title,
}) {
  const {
    control,
    formState: { errors },
  } = formMethods;

  // keep track of both the latest options _and_ the latest input value
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');

  // wrap your loader so you can stash the result in state
  const loadOptions = async input => {
    setInputValue(input);
    const items = await fetchPickListDetailsAutoComplete({
      prefixText: input,
      type,
    });
    const opts = items.map(i => ({ value: i.Code, label: i.Name }));
    setOptions(opts);
    return opts;
  };

  const handleOnBlur = () => {
    if (config?.showBackendValidation && inputValue && options.length === 0) {
      toast.error(
        config?.showBackendValidation.message ||
          `No results found for “${inputValue}”`,
        {
          className: 'toast-error',
        },
      );
    }
  };

  const moreStyles = {
    control: (provided, state) => {
      let { borderColor } = provided;
      if (errors?.[name]) {
        borderColor = 'red';
      } else if (state.isFocused) {
        borderColor = provided.borderColor;
      }
      return {
        ...provided,
        borderColor,
        '&:hover': {
          borderColor,
        },
        '&:focus': {
          borderColor,
        },
        boxShadow: errors?.[name] ? 'none' : provided.boxShadow,
        borderRadius: '8px',
      };
    },
    valueContainer: base => ({
      ...base,
      cursor: 'text',
    }),
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <div title={title}>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadOptions}
              isClearable
              className={`${errors?.[name] ? 'is-invalid' : ''}`}
              onInputChange={val => {
                setInputValue(val);
                return val;
              }}
              value={
                field.value
                  ? { value: field.value, label: String(field.value) }
                  : null
              }
              onChange={opt => {
                field.onChange(opt?.value ?? '');
              }}
              onBlur={config?.showBackendValidation ? handleOnBlur : null}
              placeholder={config?.placeholder || 'Search...'}
              styles={moreStyles}
              isDisabled={
                formType === CLAIM_FORM_TYPES.VIEW || config?.disabled
              }
              noOptionsMessage={() => null}
            />
          </div>
        )}
      />
      {errors[name] && (
        <div className="invalid-feedback">{errors[name].message}</div>
      )}
    </>
  );
}
